import React from "react";
import ReactDOM from "react-dom/client";
import { HomePage } from "@/pages/HomePage";
import { Toaster } from "@/components/ui/sonner";
import "@/styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HomePage />
    <Toaster richColors position="top-center" />
  </React.StrictMode>,
);
